const cancellationStatusConstants = {
    CANCELLATION_REQUESTED : 'Cancellation Requested',

    RETRACT_CANCELLATION_REQUEST : 'Retracted Cancellation Request',

    CANCELLATION_PENDING : 'Cancellation Pending',

    REVERT_TO_CANCELLATION_PENDING : 'Reverted to Cancellation Pending',

    CANCELLED : 'Cancelled',

    RESCINDED : 'Rescinded',

    REINSTATED : 'Reinstated'

};

angular.module('gw-um-j2js')
    .constant('cancellationStatusConstants', cancellationStatusConstants);